import axios from 'axios';
import {
  SERVER_ERROR_KEY,
  handleAxiosResponse,
  handleError,
} from '@r-and-a-shared-ui/utils';

import httpErrors, { HttpError } from 'http-errors';
import { VODByIdInput } from '../input-schemas/playback-api-input-schema';
import { VODByIDResponse } from '../response-schemas/vod-by-id-response';
import { getAuthToken, getHeader } from '../utils/queries-utils';


export const VODByIdQuery = async ({ input }: { input: VODByIdInput }) => {
  try {

    const { videoId, isAuthenticated, refreshToken, accessToken, idToken, config } = input;
    const { url, xApiKey, realm } = config;

    const authToken = await getAuthToken({
      isAuthenticated,
      refreshToken,
      accessToken,
      idToken,
      config });

    const result = await axios
      .get(`${url}/api/v4/vod/${videoId}`,
        getHeader(xApiKey!, realm!, authToken))
      .then(handleAxiosResponse)
      .catch(handleError);

    if (result.hasErrors) {
      const err = httpErrors?.[result?.statusCode as keyof typeof httpErrors]?.(
        result?.errorMessages?.join('\n'),
      ) as HttpError;
      err.name = result.data?.value?.errorKey || SERVER_ERROR_KEY;
      throw err;
    }

    return result.data as VODByIDResponse;
  } catch (err: any) {
    console.error(`Error on VOD By Id Query: ${err?.message || err}`);
    err.message = JSON.stringify(err?.name, err?.message);
    throw err;
  }
};
